package ca.derekellis.reroute.di

import ca.derekellis.reroute.RerouteApplication
import ca.derekellis.reroute.`data`.DataSource
import ca.derekellis.reroute.`data`.ResourceLoader
import ca.derekellis.reroute.db.DatabaseHelper
import ca.derekellis.reroute.map.MapDemo
import ca.derekellis.reroute.map.MapInteractionsManager
import ca.derekellis.reroute.map.ui.MapViewModel
import ca.derekellis.reroute.search.SearchViewModel
import ca.derekellis.reroute.stops.StopsViewModel
import ca.derekellis.reroute.stops.ui.Stops
import ca.derekellis.reroute.ui.Application
import kotlin.reflect.KClass
import me.tatarka.inject.`internal`.LazyMap
import me.tatarka.inject.`internal`.ScopedComponent

public fun KClass<AppComponent>.create(): AppComponent = InjectAppComponent()

public class InjectAppComponent() : AppComponent(), ScopedComponent {
  public override val _scoped: LazyMap = LazyMap()

  private val _dataSource: DataSource
    get() = _scoped.get("ca.derekellis.reroute.`data`.DataSource") {
      dataSource(
        helper = _databaseHelper
      )
    }

  private val _mapInteractionsManager: MapInteractionsManager
    get() = _scoped.get("ca.derekellis.reroute.map.MapInteractionsManager") {
      MapInteractionsManager()
    }

  private val _databaseHelper: DatabaseHelper
    get() = _scoped.get("ca.derekellis.reroute.db.DatabaseHelper") {
      DatabaseHelper()
    }

  public override val application: Application
    get() = {
      ca.derekellis.reroute.ui.Application(
        searchViewModel = _scoped.get("ca.derekellis.reroute.search.SearchViewModel") {
          SearchViewModel(
            dataSource = _dataSource,
            mapInteractionsManager = _mapInteractionsManager
          )
        }
      )
    }

  public override val mapDemo: MapDemo
    get() = {
      ca.derekellis.reroute.map.MapDemo(
        viewModel = _scoped.get("ca.derekellis.reroute.map.ui.MapViewModel") {
          MapViewModel(
            dataSource = _dataSource,
            interactionsManager = _mapInteractionsManager
          )
        }
      )
    }

  public override val stops: Stops
    get() = { arg0 ->
      ca.derekellis.reroute.stops.ui.Stops(
        viewModel = _scoped.get("ca.derekellis.reroute.stops.StopsViewModel") {
          StopsViewModel(
            dataSource = _dataSource,
            mapInteractionsManager = _mapInteractionsManager
          )
        },
        stopCode = arg0
      )
    }

  public override val rerouteApplication: RerouteApplication
    get() = _scoped.get("ca.derekellis.reroute.RerouteApplication") {
      RerouteApplication(
        resourceLoader = _scoped.get("ca.derekellis.reroute.`data`.ResourceLoader") {
          ResourceLoader(
            withDatabase = _databaseHelper
          )
        }
      )
    }
}
